module.exports = __webpack_public_path__ + "img/five.61bd9801.png";